<template>
	<div id="idFrame" ref="idFrame" style="width:100%; height:100%; display:flex;">
		<div class="TopbarItem" style="flex:0 0 auto; width:10px;"></div>
		<div class="TopbarItem" style="flex:1 0 auto; font-size:18px;">{{custName}}</div>
		<div class="TopbarItem" style="flex:3 0 auto;"></div>
		<div class="TopbarItem" style="flex:0 0 auto; padding-left:6px; padding-right:6px; cursor:pointer;">{{userAcct}}</div>
		<div class="TopbarItem" style="flex:0 0 auto; padding-left:6px; padding-right:6px; cursor:pointer;" @click="onExit">{{getLangText("退出")}}</div>
	</div>
</template>

<script>

export default {
	name: 'MyTop',
	components:{

	},
	data () {
		return {
			vueRoot: this.$parent,
			custName: "",
			userAcct: "",
		}
	},
	mounted: function(){

	},
	computed:{

	},
	methods:{
		updateInfo: function(){
			this.custName = this.login.custName;
			this.userAcct   = this.login.userAcct;
		},
		onExit: function(){
			document.location.href = "index.html";
		},
	}
}

</script>

<style scoped>

.TopbarItem{ color:#ffffff; height:100%; line-height:50px; border:0px solid #ffffff; }

</style>



// WEBPACK FOOTER //
// topbar.vue?686c3fe0